import { ILCHttpResponse } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { ChartData } from '../ui/components/charts/customComponents/helperCharts'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export const dashboardRiskHRApi = createApi({
  reducerPath: 'dashboardRiskHRApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/dashboard`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    postCountPosition: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByPosition',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountByLastStatus: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByLastStatus',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountByPositionCompletedTop10: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByPositionCompleted',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postAssesmenByPosition: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/totalAssesmenByPosition  ',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountQuestuionType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countQuestionType',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postMaxRiskbyCreatedAt: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/maxRiskByCreatedAt',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postAssesmentsCountByMaxPriority: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/assessmentsCountByMaxPriority',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postRiskByQuestionType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/questionTypeByRisk',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postTopicsWithRiskByMonth: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/topicsWithRiskByMonth',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postTotalImpactCount: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/TotalImpactCount',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCasesByStatus: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/casesByStatus',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postAssessmentsByRiskTypeCases: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/assessmentsByRiskTypeCases',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postAssessmentsByRiskType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/assessmentsByRiskType',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountByTopicWithRisk: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByTopicWithRisk',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postRiskTypeResultTopic: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/riskTypeResultTopic',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postQuestionsType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/questionType',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountByMaxRisk: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByMaxSeverity',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postCountByMaxPriority: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByMaxPriority',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postcountByPositionRiskType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByPositionRiskType',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
    postcountByDepartmentRiskType: builder.query<ILCHttpResponse<ChartData[]>, { startDate?: string; endDate?: string }>({
      query: ({ startDate, endDate }) => ({
        url: '/countByDepartmentRiskType',
        method: 'POST',
        body: {
          startDate,
          endDate,
        },
      }),
    }),
  }),
})

export const {
  useLazyPostCountPositionQuery,
  useLazyPostCountByLastStatusQuery,
  useLazyPostCountByPositionCompletedTop10Query,
  useLazyPostCountByMaxPriorityQuery,
  useLazyPostCountQuestuionTypeQuery,
  useLazyPostMaxRiskbyCreatedAtQuery,
  useLazyPostAssesmentsCountByMaxPriorityQuery,
  useLazyPostRiskByQuestionTypeQuery,
  useLazyPostTopicsWithRiskByMonthQuery,
  useLazyPostTotalImpactCountQuery,
  useLazyPostCasesByStatusQuery,
  useLazyPostAssessmentsByRiskTypeCasesQuery,
  useLazyPostAssessmentsByRiskTypeQuery,
  useLazyPostCountByTopicWithRiskQuery,
  useLazyPostRiskTypeResultTopicQuery,
  useLazyPostQuestionsTypeQuery,
  useLazyPostCountByMaxRiskQuery,
  useLazyPostAssesmenByPositionQuery,
  useLazyPostcountByPositionRiskTypeQuery,
  useLazyPostcountByDepartmentRiskTypeQuery,
} = dashboardRiskHRApi
